import React from "react";
import get from "lodash/get";
import set from "@rill/set";
import SettingsNav from "../../../parts/settings-nav";
import FaqComponent from "./FaqComponent";
import AddFaqModal from "../../../parts/modals/add-faq";
import defaultQuestions from "./faqsList";
import submit from "submit-form";
import BackArrowButton from "../../../parts/back-arrow-button";
import { getUserToRequest } from "./manage-coaches/utils/manage-coaches-utils";
import { checkOrganizationSectionPermission } from "../../../middleware/ensure-coach-permissions";
import { SettingsBackHandler } from "../../coaching-portal/settings/components/SettingsBackHandler";

class Faqs extends React.Component {
  constructor(props, ctx) {
    super(props, ctx);
    this.state = {
      selector: "default",
    };
  }

  setSelector(selector) {
    this.setState({
      selector,
    });
  }

  render() {
    const { activeUser, organizationOwner } = this.context.locals;

    //We are checking if the user is member of an organization, if it's check the owner user, if not, check the current user
    const userToRequest = getUserToRequest(activeUser, organizationOwner);

    const questions = {
      default: defaultQuestions,
      custom: userToRequest.faqs || [],
    };

    const isDefault = this.state.selector === "default";
    return (
      <main className="settings">
        <SettingsNav classNames="mobile-hidden" />
        <section className="faqs">
          <header>
            <h3 className="force-mobile-hidden">Frequently Asked Questions</h3>
            <hgroup>
              <SettingsBackHandler title={"FAQs"} />
              {!isDefault && questions[this.state.selector].length ? (
                <a
                  role="button"
                  data-button-type="primary"
                  href="/coaching-portal/settings/faqs?modal[type]=add-faq"
                  className="only-show-mobile"
                >
                  <img src="/img/new-icons/add.svg" alt="add athlete" />
                  Create new question
                </a>
              ) : null}
            </hgroup>
            <nav role="tablist">
              <a
                aria-current={isDefault || undefined}
                onClick={() => {
                  this.setSelector("default");
                }}
              >
                Default
              </a>
              <a
                aria-current={!isDefault || undefined}
                onClick={() => {
                  this.setSelector("custom");
                }}
              >
                Custom
              </a>
              {!isDefault && questions[this.state.selector].length ? (
                <a
                  role="button"
                  data-button-type="primary"
                  href="/coaching-portal/settings/faqs?modal[type]=add-faq"
                  className="mobile-hidden"
                >
                  <img src="/img/new-icons/add.svg" alt="add athlete" />
                  Create new question
                </a>
              ) : null}
            </nav>
          </header>
          <div className="content">
            <ul className="question-container">
              {questions[this.state.selector].length ? (
                questions[this.state.selector].map(
                  ({ question, answer }, idx) => (
                    <FaqComponent
                      key={parseInt(`${isDefault ? 0 : 1}${idx}`)}
                      index={idx}
                      answer={answer}
                      question={question}
                      isDefault={isDefault}
                    />
                  )
                )
              ) : (
                <section className="no-questions">
                  <article>
                    <div>
                      <p className="s1">No Custom Questions</p>
                      <p className="p4 mt-2 opacity-50">
                        Create your first custom question by clicking the button
                        below
                      </p>
                    </div>
                    <a
                      role="button"
                      data-button-type="primary"
                      href="/coaching-portal/settings/faqs?modal[type]=add-faq"
                    >
                      <img
                        src="/img/new-icons/add.svg"
                        alt="add athlete"
                        className="mr-2"
                      />
                      Create new question
                    </a>
                  </article>
                </section>
              )}
            </ul>
          </div>
        </section>
      </main>
    );
  }
}

const FaqsController = (app) => {
  app
    .get(
      "/faqs",
      set("heading", "Edit Profile"),
      (ctx, next) =>
        checkOrganizationSectionPermission(
          ctx,
          next,
          "settings",
          "/coaching-portal/settings",
          ["Owner", "Admin"]
        ),
      ({ res, req, locals, flash }) => {
        const { athlete, activeUser, organizationOwner, query } = locals;
        const modal = get(req.query, "modal", {});
        //We are checking if the user is member of an organization, if it's check the owner user, if not, check the current user
        const userToRequest = getUserToRequest(activeUser, organizationOwner);
        switch (modal.type) {
          case "edit-faq":
            if (!userToRequest.faqs[query.id]) {
              flash("error", "FAQ doesn't exist");
              res.redirect("/coaching-portal/settings/faqs");
              return;
            }
            const currentFaq = Object.assign(userToRequest.faqs[query.id], {
              index: query.id,
            });
            locals.currentFaq = currentFaq;
            break;
          default:
            break;
        }

        locals.modal = {
          "add-faq": <AddFaqModal athlete={athlete} isNew />,
          "edit-faq": <AddFaqModal athlete={athlete} isNew={false} />,
        }[modal.type];

        res.body = <Faqs />;
      }
    )
    .post(
      "/faqs",
      (ctx, next) =>
        checkOrganizationSectionPermission(
          ctx,
          next,
          "settings",
          "/coaching-portal/settings",
          ["Owner", "Admin"]
        ),
      async ({ req, locals, res, api, flash, assert, momentTZ }) => {
        const { body } = req;
        const { id, isNew, isRemoving = false, question, answer } = body;

        let newFaqs = [];
        let body_api = {};
        //We are checking if the user is member of an organization, if it's check the owner user, if not, check the current user
        const userToRequest = getUserToRequest(
          locals.activeUser,
          locals.organizationOwner
        );

        if (isRemoving) {
          // 1 - If we're removing a FAQ
          newFaqs = userToRequest.faqs;
          if (newFaqs.length > 1) {
            // If we have more than 1 FAQ remaining
            newFaqs.splice(id, 1);
            body_api = { faqs: newFaqs };
          } else {
            // If this was the last FAQ
            body_api = { action: "clear_faqs" };
          }
        } else {
          // 2-  Or if we're adding or modifying one
          assert(answer, 400, "Answer of the question can't be empty");
          assert(question, 400, "Question of the question can't be empty");
          newFaqs = isNew
            ? userToRequest.faqs
              ? [...userToRequest.faqs, { answer, question }]
              : [{ answer, question }]
            : userToRequest.faqs;
          23;
          if (!isNew) newFaqs[id] = { answer, question };
          body_api = { faqs: newFaqs };
        }

        await api(`user/${userToRequest._id}`, {
          method: "PUT",
          body: body_api,
        });

        flash("success", "Successfully updated");
        res.redirect("/coaching-portal/settings/faqs");
      }
    );
};

export default FaqsController;
